import { combineReducers, ReducersMapObject } from '@reduxjs/toolkit';
import { compoundManagementSlice, CompoundManagementState } from './compoundManagementSlice';
import { serviceOrdersSlice, ServiceOrdersState } from './serviceOrdersSlice';
import { transportAssignmentsSlice, TransportAssignmentsState } from './transportAssignmentsSlice';
import { viewSlice, ViewState } from './viewSlice';

export type PortalState = {
    transportAssignments: TransportAssignmentsState;
    serviceOrders: ServiceOrdersState;
    compoundManagement: CompoundManagementState;
    view: ViewState;
};

export const portalReducer = combineReducers<ReducersMapObject<PortalState>>({
    transportAssignments: transportAssignmentsSlice.reducer,
    serviceOrders: serviceOrdersSlice.reducer,
    compoundManagement: compoundManagementSlice.reducer,
    view: viewSlice.reducer,
});
